document.addEventListener("DOMContentLoaded",()=>{

    document.querySelectorAll(".size-chart-v2").forEach(chart=>{

        const buttons=chart.querySelectorAll(".size-chart-toggle button");
        const panels=chart.querySelectorAll(".size-chart-panel");

        buttons.forEach(button=>{

            button.addEventListener("click",()=>{

                buttons.forEach(btn=>btn.classList.remove("active"));

                button.classList.add("active");

                const target=button.dataset.target;

                panels.forEach(panel=>{

                    panel.classList.remove("active");

                    if(panel.dataset.panel===target){

                        panel.classList.add("active");

                    }

                });

            });

        });

    });

});

function copyCoupon(id, button){

    const code = document.getElementById(id).innerText;

    navigator.clipboard.writeText(code);

    const old = button.innerHTML;

    button.innerHTML="✓ Copied";

    setTimeout(()=>{
        button.innerHTML=old;
    },2000);

}